import * as React from "react"
import { Center, Spinner } from "@chakra-ui/react"
import type { NextPage } from "next"
import { useRouter } from "next/router"

import { REDIRECT_PATH } from "lib/config"
import { Role } from "lib/graphql"
import { useMe } from "lib/hooks/useMe"

type NextPageWithLayout = NextPage & {
  getLayout?: (page: React.ReactElement) => React.ReactNode
}

export function withNoAuth(Page: NextPageWithLayout) {
  function NoAuthComponent(props: any) {
    const { me, loading } = useMe()
    const router = useRouter()
    const redirect = router.query[REDIRECT_PATH] as string | undefined

    React.useEffect(() => {
      if (loading || !me || !router.isReady) return
      router.replace(redirect || (me.role === Role.Admin ? "admin/gebruikers" : `users/${me.id}`))
    }, [loading, me, router, redirect])

    if (loading || me)
      return (
        <Center minH="100vh">
          <Spinner />
        </Center>
      )
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return <Page {...props} />
  }

  const getPageLayout = Page.getLayout ?? ((page: React.ReactElement) => page)
  NoAuthComponent.getLayout = (page: React.ReactElement) => <>{getPageLayout(page)}</>
  return NoAuthComponent
}
